// Renders a link to an external resource. I.E. It will not go through React Router.
export { default } from 'mineral-ui/Link';
